<template>
    <v-dialog
        v-model="showDialog"
        persistent
        width="900"
    >
        <v-card v-if="data">
            <v-form
                ref="form"
                v-model="form"
                @submit.prevent="submitForm"
            >
                <v-card-title style="background-color: #009688; color: white;">
                    {{ data.RATE_TYPE === 'PACKAGE' ? 'PACKAGE' : 'DIAGNOSTIC' }} NAME: &nbsp;<v-chip>{{ data.DIA_T ? data.DIA_T : '' }}</v-chip>
                </v-card-title>
                <v-card-text>
                    <v-autocomplete
                        ref="diagnosticName"
                        key="rateType2"
                        v-model="diagnosticName"
                        :items="rateOptions"
                        multiple
                        return-object
                        item-text="DIA_T"
                        label="Diagnostic/Package Name"
                        color="teal"
                        :rules="[v => v !== '' && v !== null && v !== undefined && v.length > 0 || 'This field is required']"
                        clearable
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        width="120"
                        :disabled="loading"
                        @click="showDialog = false"
                    >
                        <v-icon>{{ mdiClose }}</v-icon>
                        close
                    </v-btn>
                    <v-btn
                        color="teal darken-1"
                        width="120"
                        style="color: white;"
                        type="submit"
                        :loading="loading"
                        @mouseover="$refs.diagnosticName.blur()"
                    >
                        <v-icon>{{ mdiCheck }}</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
    mdiClose,
    mdiCheck
} from '@mdi/js'
export default {
    props: ['show', 'data', 'rateItems', 'notif'],
    data: () => ({
        mdiClose,
        mdiCheck,
        form: false,
        diagnosticName: [],
        isNewLinkSuccessful: false,
        loading: false
    }),
    computed: {
        ...mapGetters(['linkDiagRateData', 'viewLinkedDiagRateData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$refs.form.reset()
                this.$emit('closeDialog')
            }
        },
        rateOptions() {
            if (this.data && this.data.LINKS && this.viewLinkedDiagRateData && this.viewLinkedDiagRateData.data)
                return this.rateItems
                    .filter(itemA => !this.data.LINKS.some(itemB => itemA.ID === itemB.ID))
                    .filter(itemA => !this.viewLinkedDiagRateData.data.some(itemB => itemA.ID === itemB.ID))
                    .filter(item => this.data.ID !== item.ID)
            else return []
        }
    },
    watch: {
        async show(newVal) {
            if (newVal) {
                await this.viewLinkedDiagRate({ IS_LINKED_TO: this.data.ID, MSU_C: this.data.MSU_C })
            }
        }
    },
    methods: {
        ...mapActions(['linkDiagRate', 'viewLinkedDiagRate', 'getPackageDiagnostics']),
        async submitForm() {
            if (this.$refs.form.validate()) {
                this.loading = true
                this.isNewLinkSuccessful = false
                const results = await Promise.allSettled(
                    this.diagnosticName.map(item => this.linkDiagRate({ RATE_ID: item.ID, LINK_TO: this.data.ID, MSU_C: item.MSU_C }))
                )
                const failures = results
                    .map((r, i) => ({ ...r, index: i }))
                    .filter(r => r.status === 'rejected')

                this.isNewLinkSuccessful = failures && failures.length === 0
                if (failures.length === 0) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'New diagnostic/package has been saved.'
                    this.notif.show = true
                    await this.viewLinkedDiagRate({ IS_LINKED_TO: this.data.ID, MSU_C: this.data.MSU_C })
                    this.$emit('showIndexPage', { ...this.data, type: this.data.LINKS.length > 0 ? 'show' : 'add' })
                    this.isNewLinkSuccessful = false
                    this.$emit('refreshMsuRates')
                    this.showDialog = false
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = this.linkDiagRateData.state
                    this.notif.show = true
                }
                this.loading = false
            }
        }
    }
}
</script>
